<template>
  <div class="main">
    <NavMenu class="navMenu"/>
    <div class="navMenuBot">
        <div class="content2">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in  themeList" :key="index" @click="itemClick(index,item)" :class="{active:index == currentIndex }">
                        {{item.title}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="appContent">
      <keep-alive exclude="schoolList,schoolDetail,linkDetail,application,myOrder,orderDetail,trainOrderDetail">
        <router-view></router-view>
      </keep-alive>
    </div>
    <div class="qrcodeDialog">
      <!-- <div id="qrcode" style="width:160px; height:160px; margin-top:15px;"></div> -->
      <img :src="qrcode">
      <div class="title" v-if="mobile" style="font-size: 12px;">高考志愿扫一扫</div>
      <div class="title" v-if="pc">高考志愿扫一扫</div>
    </div>
    <Footer />
  </div>
</template>

<script>
import NavMenu from "components/content/navMenu/NavMenu";
import Footer from "components/content/footer/Footer";
import Swiper from "assets/swiper/swiper.js"
import { getThemeList } from "network/home.js";
export default {
  data() {
    return {
        qrcode:'',
        themeList:[],
        currentIndex:0,
        mobile:false,
        pc:false
    };
  },
  components: {
    NavMenu,
    Footer
  },
  created(){
    this.getQrCode()
    this.getThemeListData(1,100)
    this.currentIndex = this.$store.state.navIndex - 1
  },
  methods: {
    getThemeListData(page,pageSize) {
      getThemeList({
        page,
        pageSize
      }).then(res => {
        console.log(res);
        let data = res.data.records
        this.themeList = data;
        localStorage.setItem('navData',JSON.stringify(data))

        this.$nextTick(()=>{
            new Swiper('.swiper-container', {
                slidesPerView: 'auto',
                spaceBetween: 0,
                freeMode: true
            });
        })
      });
    },
    goTop() {
        // 回到顶部
        document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    itemClick(index,item){
        if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          if(item.themeLink){
            let url = 'http://hyt.m.daodao.pro'
            console.log(url);
            window.open(url)
          }else{
            this.currentIndex = index
            this.$store.dispatch('getNavIndex',Number(index) + 1)
            this.goTop()
            let url = window.location.href
            this.$router.push('/index')
          }
        } else {
          if(item.themeLink){
            window.open(item.themeLink)
          }else{
            this.currentIndex = index
            this.$store.dispatch('getNavIndex',Number(index) + 1)
            this.goTop()
            let url = window.location.href
            
            this.$router.push('/index')
          }
        }
        // if(item.themeLink){
        //   window.open(item.themeLink)
        // }else{
        //   this.currentIndex = index
        //   this.$store.dispatch('getNavIndex',Number(index) + 1)
        //   this.goTop()
        //   let url = window.location.href
        //   // if(url.indexOf('index') == -1){
        //       // this.$router.push('/index')
        //   // }
        //   this.$router.push('/index')
        // }
    },
    getQrCode() {
      if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        //手机端
        this.qrcode = require('../../assets/img/mobileCode.png')
        this.mobile = true
        this.pc = false
      } else {
        //pc端
        this.qrcode = require('../../assets/img/pcCode.png')
        this.mobile = false
        this.pc = true
      }
    }
  }
};
</script>

<style>
/* 这边路径简写（在vue.config.js配置了） */
/* @import "assets/css/base.css"; */
@import "~assets/swiper/swiper.css";
.navMenuBot{
    width:100%;
    position: fixed;
    top:80px;
    left:0;
    background: var(--color-main);
    z-index:11;
}
.content2{
    width:1200px;
    margin:0 auto;
}
.swiper-slide{
    width:auto;
    padding:21px 25px;
    /* min-width: 300px; */
    color:#fff;
    cursor: pointer;
}
.active{
    background: #5fbf40;
}
.qrcodeDialog {
  background-color: #fff;
  text-align: center;
  position: fixed;
  right: 2%;
  bottom: 20%;
  width: 160px;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.qrcodeDialog img {
  width: 160px;
  height: 160px;
}
.qrcodeDialog title {
  text-align: center;
  font-size: 20px;
  color: black;
}
@media screen and (max-width: 768px){
    .content2{
        width: 100%;
    }
    .navMenuBot{
        position: fixed;
        top:1rem;
        left:0;
    }
    .swiper-slide{
        padding:0.22rem 0.5rem;
        color:#fff;
        cursor: pointer;
        font-size:0.3rem;
    }
    .qrcodeDialog {
      z-index: 9999;
      background-color: #fff;
      text-align: center;
      position: fixed;
      right: 2%;
      bottom: 20%;
      width: 85px;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }
    .qrcodeDialog img {
      width: 85px;
      height: 80px;
    }
    .qrcodeDialog title {
      text-align: center;
    }
}
</style>
